// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1b7pO","copyright":"Footer_copyright__MZ4QY","toTop":"Footer_toTop__1wh1z","terms":"Footer_terms__1wQ-I"};